import React from 'react'
import Link from 'next/link'
import { Card } from 'components'
import { Button } from 'controls'
import { image } from 'services'
import { companyConfig } from 'globalConfigApp'

import { contractVersionNotAllowedMessageCss } from './styles'

const ContractVersionNotAllowedPageMessage = () => (
  <div className="general-not-allowed-page-message">
    <Card bordered>
      <div className="general-not-allowed-page-message-content">
        <h3>¡Lo sentimos! tu actual versión de contrato no tiene acceso a este página</h3>
        <picture>
          <img
            src={image('icono-admin-fullservice.png')}
            alt={`${companyConfig.name} full service`}
          />
        </picture>

        <p>
          Consulta con el equipo de {companyConfig.name} para obtener más detalle
          de las capacidades de tu contrato.
        </p>
        <p>
          Envía un email a{' '}
          <a
            href={`mailto:info@${companyConfig.companyDomain}?Subject=Acceso a página no permitido`}
            target="_top"
            className="link"
          >
            {`info@${companyConfig.companyDomain}`}
          </a>{' '}
          para obtener más información
        </p>
      </div>
    </Card>
    <style jsx>{contractVersionNotAllowedMessageCss}</style>
  </div>
)

export default ContractVersionNotAllowedPageMessage
